import { useEffect } from 'react';

import {
  useAuthState,
  useClearDispatch,
  DISCONNECTION_REASONS,
  DISCONNECTION_REASON_STORAGE_KEY,
} from '@contexts/auth/AuthContext';
import { removeBasketDetailsOnLocalStorage } from '@utils/removeBasketDetailsOnLocalStorage';
let logoutTime: NodeJS.Timeout;

const AuthTokenExpiration = () => {
  const clearUserInformation = useClearDispatch();
  const token = typeof window !== 'undefined' && localStorage.getItem('token');
  const { tokenExpirationDate } = useAuthState();
  useEffect(() => {
    if (token && tokenExpirationDate) {
      logoutTime = setTimeout(async () => {
        /**
         * Clear user information from context
         */
        clearUserInformation();

        /**
         * Remove basket details from local storage when user token expires
         */
        removeBasketDetailsOnLocalStorage();

        /**
         * Set disconnection reason in local storage
         */
        if (typeof window !== 'undefined')
          localStorage.setItem(
            DISCONNECTION_REASON_STORAGE_KEY,
            DISCONNECTION_REASONS.SESSION_EXPIRATION
          );
      }, tokenExpirationDate.getTime() - new Date().getTime());
    } else {
      clearTimeout(logoutTime);
    }
  }, [token, clearUserInformation, tokenExpirationDate]);

  return null;
};

export default AuthTokenExpiration;
